import { useState } from 'react'
import { UserState } from '@mprolab/sdk'
import { useWeb3React } from 'lib/wagmi-compat/useWeb3React'
import { useIsUserVerified } from 'state/user/hooks'

export const useUserVerificationState = () => {
  const { account } = useWeb3React()
  const isUserVerified = useIsUserVerified()

  const getInitialState = (account?: string, isVerified?: boolean): UserState => {
    if (account && isVerified) {
      return UserState.VERIFIED
    }
    if (account && !isVerified) {
      return UserState.AUTHORIZED
    }
    return UserState.UNAUTHORIZED
  }

  const [verificationState, setVerificationState] = useState(getInitialState(account, isUserVerified))

  return { verificationState, setVerificationState }
}
